module.exports = __webpack_public_path__ + "img/x-close.dc2f980d.svg";